import { UserManager, Log, User } from 'oidc-client';

/* eslint-disable */
class CognitoUserManager extends UserManager {
  _signinStart(args, navigator, navigatorParams = {}) {
    Log.debug('_signinStart for Cognito');

    return navigator.prepare(navigatorParams).then((handle) => {
      Log.debug('got navigator window handle');

      return (this.createSigninRequest && this.createSigninRequest(args)
        .then((signinRequest) => {
          Log.debug('got signin request');

          navigatorParams.url = signinRequest.url.replace('%20id_token', '');
          navigatorParams.id = signinRequest.state.id;

          return handle.navigate(navigatorParams);
        })
        .catch((err) => {
          if (handle.close) {
            Log.debug(
              'Error after preparing navigator, closing navigator window',
            );
            handle.close();
          }
          throw err;
        }));
    });
  }

  signinWithRefreshToken(refreshToken) {
    return this._tokenClient
      .exchangeRefreshToken({ refresh_token: refreshToken })
      .then((user) => {
        const newUser = new User(this._manageClaims(user, refreshToken));
        return this.storeUser(newUser);
      });
  }

  _manageClaims(user, refreshToken) {
    const jwt = this._joseUtil.parseJwt(user.id_token).payload;

    user.scope = this.settings.scope;
    user.expires_at = jwt.exp;
    user.refresh_token = refreshToken;
    user.profile = jwt;
    user.profile.username = jwt['cognito:username'] || jwt.sub;

    delete user.profile.at_hash;
    delete user.profile.aud;
    delete user.profile.exp;
    delete user.profile.iat;
    delete user.profile.iss;

    return user;
  }
}

export default CognitoUserManager;
